import { render, staticRenderFns } from "./LinkChat.vue?vue&type=template&id=8eb3e5ce&scoped=true&"
import script from "./LinkChat.vue?vue&type=script&lang=js&"
export * from "./LinkChat.vue?vue&type=script&lang=js&"
import style0 from "./LinkChat.vue?vue&type=style&index=0&id=8eb3e5ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb3e5ce",
  null
  
)

export default component.exports